import React from "react"

export const LegalLanguage: React.FC = () => {
  return (
    <p className="italic text-gray-700 text-sm">
      By using bandNada you are agreeing to our{" "}
      <a className="text-blue-600" target="_blank" rel="noreferrer" href="/terms_of_service">
        Terms of Service
      </a>
      , and our{" "}
      <a className="text-blue-600" target="_blank" rel="noreferrer" href="/privacy">
        Privacy Policy
      </a>
      .
    </p>
  )
}
